import * as React from 'react';

import BudgetApproval56 from './BudgetApproval56';

export const budgetApproval56 = () => <BudgetApproval56 />;

export default {
    title: 'Illustration|BudgetApproval56',
    component: BudgetApproval56,
    parameters: {
        notes: "`import BudgetApproval56 from 'box-ui-elements/es/illustration/BudgetApproval56';`",
    },
};
